import { render, staticRenderFns } from "./BillingSystemTest.vue?vue&type=template&id=2bed1248&scoped=true"
import script from "./BillingSystemTest.vue?vue&type=script&lang=js"
export * from "./BillingSystemTest.vue?vue&type=script&lang=js"
import style0 from "./BillingSystemTest.vue?vue&type=style&index=0&id=2bed1248&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bed1248",
  null
  
)

export default component.exports